export enum ESyncType {
  FullSync = 0,
  SensitiveSync = 1,
  NoSync = 2
} 